import {useFeatureIsOn} from "@growthbook/growthbook-react";
import gql from "graphql-tag";

import {useQuery} from "@khan/data-gql";
import {gqlOp} from "@khan/data-gql-core";

import type {
    userMayInputImages,
    userMayInputImagesVariables,
} from "./__graphql-types__/userMayInputImages.ts";

export const USER_MAY_INPUT_IMAGES_QUERY = gqlOp<
    userMayInputImages,
    userMayInputImagesVariables
>(gql`
    query userMayInputImages {
        user {
            id
            includesDistrictOwnedData
            districtEnableImageInput
        }
    }
`);

export function useUserMayInputImages() {
    const shouldBypassDXCheck = useFeatureIsOn("image-input-bypass-dx-check");

    const [result] = useQuery(USER_MAY_INPUT_IMAGES_QUERY, {
        variables: {},
        skip: false,
    });

    if (!result || result.status !== "success") {
        return false;
    }

    if (!result.data?.user) {
        return false;
    }

    if (shouldBypassDXCheck) {
        return true;
    }

    if (!result.data.user.includesDistrictOwnedData) {
        return true;
    }

    return result.data.user.districtEnableImageInput ?? false;
}
